export const Unmuted = (props: any) => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 48 48"
      {...props}
    >
      <g>
        <path
          fill="#333"
          d="M25.242 7.654c.648.78.796 1.748.859 2.45.066.735.066 1.673.066 2.746v22.3c0 1.073 0 2.011-.066 2.746-.063.703-.21 1.67-.859 2.45a4 4 0 0 1-3.268 1.437c-1.012-.049-1.826-.594-2.386-1.022-.586-.448-1.277-1.082-2.068-1.807l-5.132-4.704H10.56c-.778 0-1.478 0-2.06-.047-.625-.051-1.288-.166-1.937-.498a5 5 0 0 1-2.186-2.185c-.33-.65-.446-1.312-.497-1.936-.048-.583-.048-1.283-.047-2.061v-7.046c0-.778 0-1.478.047-2.06.051-.625.166-1.288.497-1.937a5 5 0 0 1 2.186-2.186c.65-.33 1.312-.446 1.936-.497.583-.048 1.283-.048 2.061-.047h1.828l5.132-4.704c.79-.725 1.482-1.36 2.068-1.807.56-.428 1.374-.973 2.386-1.022a4 4 0 0 1 3.268 1.437Zm-3.225 2.763c-.426.325-.984.834-1.861 1.639l-5.18 4.747-.033.031c-.121.113-.372.346-.677.52a3.004 3.004 0 0 1-.826.322 3.773 3.773 0 0 1-.851.074H10.632c-.873 0-1.407.001-1.807.034a2.546 2.546 0 0 0-.367.05.605.605 0 0 0-.08.025 1 1 0 0 0-.436.437l-.007.015a.603.603 0 0 0-.018.064 2.56 2.56 0 0 0-.05.367c-.033.4-.034.934-.034 1.808v6.9c0 .873.001 1.408.034 1.808.015.186.034.299.05.367a.603.603 0 0 0 .025.08 1 1 0 0 0 .452.443c.01.004.031.01.064.018.068.016.18.035.367.05.4.033.934.034 1.808.034h1.956c.166 0 .508-.003.85.074.29.066.57.174.827.322.305.174.556.407.677.52l.034.03 5.179 4.748c.877.805 1.435 1.314 1.861 1.639l.089.066.011-.11c.048-.534.05-1.289.05-2.479V12.94c0-1.19-.002-1.945-.05-2.479a4.94 4.94 0 0 0-.011-.11l-.089.066Z"
          clipRule="evenodd"
          fillRule="evenodd"
          data-follow-fill="currentColor"
        ></path>
        <path
          fill="#333"
          d="M32.411 16.78c-.538-.592-1.411-.152-1.411.648v13.063c0 .8.873 1.24 1.411.648C33.997 29.397 35 26.827 35 23.96c0-2.867-1.003-5.438-2.589-7.18Z"
          data-follow-fill="currentColor"
        ></path>
        <path
          fill="#333"
          d="M34.67 40.986c.27.52.939.665 1.389.29 4.152-3.47 6.94-9.908 6.94-17.276s-2.788-13.806-6.94-17.275a.907.907 0 0 0-1.39.288c-.34.652-.66 1.341-.96 2.065-.165.398-.04.851.273 1.148a12.637 12.637 0 0 1 1.64 1.926C37.63 15.02 39 19.197 39 24c0 4.803-1.37 8.98-3.378 11.848a12.637 12.637 0 0 1-1.64 1.926c-.313.297-.438.75-.273 1.148.3.724.62 1.413.96 2.065Z"
          data-follow-fill="currentColor"
        ></path>
      </g>
    </svg>
  )
}
